// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__nZ4nJ","nav__link":"Nav_nav__link__zU6J5"};